module.exports = __webpack_public_path__ + "img/header-engagementRingsFancy@2x.31a4e12.jpg";